<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="课程名称" prop="courseId" >
<!--        <a-input v-model="form.courseId" placeholder="请输入课程ID，外键{course.id}" />-->

        <a-select @change="changeSelect" placeholder="全部" show-search v-model:value="form.courseId"
                  option-filter-prop="children" :filterOption="filterOption">
          <a-select-option v-model:value="item.id" v-for="(item, index) in courseList" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>

      </a-form-model-item>
      <a-form-model-item label="第几节" prop="section" >
        <a-input v-model="form.section" placeholder="请输入第几节" />
      </a-form-model-item>
      <a-form-model-item label="课程标题" prop="name" >
        <a-input v-model="form.name" placeholder="请输入课程标题" />
      </a-form-model-item>

      <a-form-model-item label="是否试看 " prop="andSee" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.andSee">
          <a-radio :value=1>不能试看</a-radio>
          <a-radio :value=0>可以试看</a-radio>
        </a-radio-group>
      </a-form-model-item>
<!--      <a-form-model-item label="课程视频" prop="picture" >-->
<!--        <file-upload v-model="form.picture" placeholder="请输入课程视频" type="video" />-->
<!--      </a-form-model-item>-->

      <a-form-model-item label="课程视频" prop="picture">
        <file-upload   type="file" :defaultList="form.pictureArr" :count="form.pictureCount"
                     @input="getImg($event, 'picture')" accept=".mp4"></file-upload>

          <video v-if="form.picture"  style="width: 180px;height: 120px"
                   class="avatar video-avatar"
                   controls="controls"  :src="form.pictureArr[0].url"/>
      </a-form-model-item>

<!--      <a-form-model-item label="课程类型 " prop="type" >-->
<!--        <a-radio-group name="radioGroup" :default-value="0" v-model="form.type">-->
<!--          <a-radio :value=0>会员可看</a-radio>-->
<!--          <a-radio :value=1>非会员可看</a-radio>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="排序" prop="sort" >
        <a-input v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getCatalogue, addCatalogue, updateCatalogue, courseName} from '@/api/catalogue/catalogue'
import {guid} from "@/utils/ruoyi";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      courseList:[],
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        video: '',
        pictureCount: 1,
        pictureArr: [],
        courseId: null,
        courseName: null,

        section: null,

        name: null,

        picture: null,

        type: null,
        andSee: null,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          courseId: [
          { required: true, message: '课程ID，外键{course.id}不能为空', trigger: 'blur' }
        ],
        section: [
          { required: true, message: '第几节不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '课程标题不能为空', trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '课程视频不能为空', trigger: 'blur' }
        ],
        // type: [
        //   { required: true, message: '课程类型 0-会员可看 1-非会员可看不能为空', trigger: 'change' }
        // ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    changeSelect(val){
      console.log(val,"val")
    },
    filterOption(input, option) {
      // 重点在这
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        pictureArr: [],
        courseId: null,
        courseName: null,
        section: null,
        name: null,
        picture: null,
        type: null,
        andSee: 1,
        sort: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (courseId) {

      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.getCourseList()
      this.$nextTick(() => {
        this.form.courseId =courseId!=null?courseId:null
    })
    },

  /** 查询课程名称 */
    getCourseList() {
      courseName().then(Response => {
          console.log(Response)
          this.courseList = Response.data
        }
      )
    },

    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getCourseList()
      this.formType = 2
      const id = row ? row.id : ids
      getCatalogue({"id":id}).then(response => {
        this.form = response.data
        let that = this;
        this.form.pictureArr = []
        this.form.pictureArr.push({
          uid: guid(8, 10),
          name: that.form.picture,
          status: 'done',
          halfUrl: that.form.picture,
          url: that.form.picture,
          path: that.form.picture
        })


        this.form.courseId = this.form.courseId.toString()
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null&&this.form.pictureArr.length>0) {
            updateCatalogue(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCatalogue(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (img.indexOf(",") === -1) {
        // 单图
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(",")
          if (imgArr.length) {
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /**视频上传成功后的回调 */
    getVideo(info, fieldName) {
      console.log('视频上传成功后的回调数据 info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].halfUrl
          this.form[`${fieldName}Arr`] = info

        } else {
          this.form[fieldName] = info.map(ele => { return ele.halfUrl }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video;
      this.previewVisible = true;
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /******************** 上传图片数据处理 end   ********************/

  }
}
</script>
